<template>
  <div class="md-layout">
    <div class="md-layout-item md-small-size-100">
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title">Location</h4>
          </div>
        </md-card-header>

        <md-card-content>
          <l-map style="height: 75vh;" :zoom="zoom" :center="center">
            <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
            <l-marker 
            :options="{markerColor: 'red'}"
            v-for="marker in markerPositions"
            :key="marker.LORA_ID"
            :lat-lng="[marker.latitude, marker.longitude]">
              <l-popup v-if="marker.type == 'CLIENT'">Client {{marker.name}} ({{marker.LORA_ID}})</l-popup>
              <l-popup v-if="marker.type == 'GW'">Gateway {{marker.name}} ({{marker.LORA_ID}})</l-popup>
            </l-marker>
          </l-map>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>

import axios from "axios";

//DOC MAPS: https://vue2-leaflet.netlify.app/
import L from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import { Icon } from "leaflet";

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup
  },

  data() {
    return {
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 13,
      center: [48.71642959770993, 21.261006986588413],
      markerPositions: []
    };
  },

  computed: {
    getAuth() {
      return this.$store.getters.getAuth;
    }
  },

  mounted() {
    this.getAPIData();
  },

  methods: {
    getAPIData() {
      axios({
        method: "GET",
        //url: "https://run.mocky.io/v3/69f45dd6-39c9-4155-8cb4-2604e6f59bf3",
        url: this.$ENDPOINTS.API + "/location",
        headers: {
          Authorization: "Bearer " + this.getAuth.token
        }
      })
        .then(response => {
          this.markerPositions = response.data.data;
        })
        .catch(error => {
          console.log("ERROR: ", error);
        });
    }
  }
};
</script>